export var logic = {
    result: 'defaultLabel',
};
